/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Alpha_TitleInputs */

const en_landing_capability_alpha_title = /** @type {(inputs: Landing_Capability_Alpha_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock your research alpha`)
};

/**
* | output |
* | --- |
* | "Unlock your research alpha" |
*
* @param {Landing_Capability_Alpha_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_alpha_title = /** @type {((inputs?: Landing_Capability_Alpha_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Alpha_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_alpha_title(inputs)
});